import { render, staticRenderFns } from "./mainSect.vue?vue&type=template&id=fb568720&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb568720",
  null
  
)

export default component.exports